import React, { useContext, useEffect, useState } from "react";
import styled from "@emotion/styled";
import MUIDataTable from "mui-datatables";
import axios from "axios";

import { NavLink, useNavigate } from "react-router-dom";

//Components
import StaffManagementContext from "../../context/StaffManagementContext";
import {
  Avatar,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Switch,
  TableRow,
  TableCell,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import Detail from "./Detail";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import ProfileContext from "../../context/ProfileContext";
import useAuth from "../../hooks/useAuth";
// import api from "../../../api/mainApi";

// ==============================|| Course List ||============================== //
const muiCache = createCache({
  key: "mui",
  prepend: true,
});
function Staffs({display}) {
  const navigate = useNavigate();
  const api = useAxiosPrivate();
  const profileContext = useContext(ProfileContext);
  const { user } = useAuth();
  const staffContext = useContext(StaffManagementContext);
  const [modalState, setModalState] = useState({
    open: false,
    name: null,
    staff_id: null,
    disabled: null,
  });
  const [added, setAdded] = useState({ status: false });

  const handleClose = () => {
    setModalState({ ...modalState, open: false });
  };
  const handleOpen = (staff_id) => {
    let staff = staffContext.state.filter((staff) => {
      return staff.id === staff_id;
    })[0];
    console.log(staff);
    setModalState({
      name:
        staff.first_name || staff.middle_name
          ? staff.first_name + " " + staff.middle_name
          : null,
      staff_id: staff_id,
      open: true,
      disabled: !checkDate(staff.end_date),
    });
  };
  const handleDisable = () => {
    api
      .patch("/staff/disableStaff", { id: modalState.staff_id })
      .then((response) => {
        //alert(JSON.stringify(response, null, 2));
        setAdded({ status: Boolean(response.data.status) });
      })
      .catch((err) => {
        alert(JSON.stringify(err.response.data, null, 2));
      });
    handleClose();
  };

  useEffect(() => {
    api
      .get("staff/staffs")
      .then((staffs) => {
        console.log(JSON.stringify(staffs.data, null, 2));
        staffContext.dispatch({
          type: "loadStaff",
          staffs: staffs.data.staffs,
        });
      })
      .catch((err) => console.log(err));
  }, [added]);
  useEffect(() => {
    api
      .get("staff/staffs")
      .then((staffs) => {
        console.log(JSON.stringify(staffs.data, null, 2));
        staffContext.dispatch({
          type: "loadStaff",
          staffs: staffs.data.staffs,
        });
      })
      .catch((err) => console.log(err));
  }, []);

  let staffs = staffContext?.state
    ?.filter((s) => s.reg_status == "Active")
    ?.map((staff) => {
      console.log(staff);
      let newstaff = {
        fullName: staff.first_name
          ? staff.first_name + " " + staff.middle_name
          : "",
        id: staff.id,
        phone_no: staff.phone_no,
        email: staff.email,
        qualification: staff.qualification,
        status: staff.status?.name,
        position: staff.position?.name,
        rank: staff.rank?.name,
        load: staff.load,
        office: staff.office?.name,
        start_date: staff?.start_date,
        end_date: staff?.end_date,
        pic: staff?.pic,
        disable: staff.id,
      };
      console.log("new staff, ", newstaff);
      return newstaff;
    });

  const columnHead = [
    {
      label: "Full Name",
      name: "fullName",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Box sx={{ display: "flex", alignItems: "center", gap: "0.8rem" }}>
              <Avatar
                src={
                  profileContext?.state?.host +
                  tableMeta.tableData[tableMeta.rowIndex]?.pic?.slice(1) +
                  `?token=${user?.accessToken}`
                }
              >
                {value[0]?.toUpperCase()}
              </Avatar>
              {value}
            </Box>
          );
        },
      },
    },
    {
      label: "ID",
      name: "id",
      options: {
        filter: false,
        display: "none",
      },
    },
    {
      label: "Phone No",
      name: "phone_no",
      options: {
        filter: false,
        display: "exlude",
      },
    },
    {
      label: "Email",
      name: "email",
      options: {
        filter: true,
      },
    },
    {
      label: "Qualification",
      name: "qualification",
      options: {
        filter: true,
        display: "none",
      },
    },

    {
      label: "Employment Type",
      name: "status",
      options: {
        filter: true,
      },
    },
    {
      label: "Position",
      name: "position",
      options: {
        filter: true,
        display: "exclude",
      },
    },
    {
      label: "Academic Rank",
      name: "rank",
      options: {
        filter: true,
      },
    },
    {
      label: "Load(LEH)",
      name: "load",
      options: {
        filter: false,
      },
    },
    {
      label: "End Date",
      name: "end_date",
      options: {
        filter: false,
        display: "false",
      },
    },
    {
      label: "Department",
      name: "office",
      options: {
        filter: true,
        display: "none",
      },
    },
    {
      label: "Action",
      options: {
        filter: false,
        sort: true,
        display: display== 'yes'?false:true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div
              style={{ width: "100px", display: "flex", alignItems: "center" }}
            >
              <EditIcon
                color="primary"
                onClick={() => {
                  navigate("./editStaff", {
                    state: { id: value },
                  });
                }}
              />
              <Switch
                checked={checkDate(
                  tableMeta.tableData.filter((row, index) => {
                    if (row.id == value) {
                      return true;
                    }
                    return false;
                  })[0].end_date
                )}
                onClick={() => {
                  handleOpen(value);
                }}
              />
              {tableMeta.tableData.filter((row) => {
                console.log(row.disable);
              })}
              {/*</NavLink>*/}
            </div>
          );
        },
      },
      name: "disable",
    },
  ];

  const options = {
    selectableRows: false,
    expandableRows: true,
    renderExpandableRow: (rowData, rowMeta) => {
      //course code is found using index

      const colSpan = rowData.length + 1;
      let staff = staffContext.state.filter((s) => rowData[1] === s.id)[0];
      return (
        <TableRow>
          <TableCell colSpan={colSpan}>
            <Detail
              details={[
                {
                  office: staff.office.name,
                  position: staff.position.name,
                  [`phone number`]: staff.phone_no || "",
                  qualification: staff.qualification,
                },
                {
                  [`start date`]: staff.start_date,
                  [`end date`]: staff.end_date,
                },
              ]}
            />
          </TableCell>
        </TableRow>
      );
    },
  };
  let checkDate = (date) => {
    let end_date = new Date(date).getTime();
    let now = new Date().getTime();
    if (end_date > now || !date) {
      return true;
    }
    return false;
  };
  const StyledMUIDataTable = styled(MUIDataTable)(({ theme }) => ({
    background: theme.palette.background.default,
  }));
  return (
    <>
      <CacheProvider value={muiCache}>
        <StyledMUIDataTable
          title={""}
          data={staffs}
          columns={columnHead}
          options={options}
        />
      </CacheProvider>

      <Dialog open={modalState.open} onClose={handleClose}>
        <DialogTitle id="alert-dialog-title">
          {modalState.disabled ? "Enable " : "Disable "}
          {modalState.name ? modalState.name : modalState.staff_id} ?
        </DialogTitle>
        <DialogContent>
          {modalState.disabled
            ? "The staff is going to be enabled"
            : "The Staff is going to disabled"}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} sx={{ color: "third.dark" }}>
            cancel
          </Button>
          <Button variant="outlined" color="secondary" onClick={handleDisable}>
            {modalState.disabled ? "Enable" : "Disable"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default Staffs;
